<template>
  <div>
    <!-- Button -->
    <v-btn
      :loading="loading"
      :disabled="loading || disabled"
      :small="$vuetify.breakpoint.xsOnly"
      color="primary"
      class="mx-0"
      @click="toЕxcel()"
    >
      To Excel
      <v-icon
        :small="$vuetify.breakpoint.xsOnly"
        :class="{ 'ml-2': $vuetify.breakpoint.xsOnly }"
        right
      >
        fa-file-excel-o
      </v-icon>
    </v-btn>

    <!-- Form -->
    <form
      v-if="criteria"
      ref="form"
      :action="normalizedURL"
      method="POST"
      @submit.prevent
    >
      <input
        :value="JSON.stringify(criteria)"
        type="hidden"
        name="criteria"
      >
    </form>

    <!-- Dialog: Subscription Required -->
    <v-dialog
      v-model="subscriptionRequiredDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          Subscription Required
        </v-card-title>
        <v-card-text>
          A subscription is required to export data to Excel
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            color="primary"
            @click="subscriptionRequiredDialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Modules
import { mapState } from 'vuex'

export default {
  props: {
    url: {
      type: String,
      required: true
    },
    criteria: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    subscriptionRequiredDialog: false,
    loading: false
  }),

  computed: {
    ...mapState({
      user: state => state.user,
      selectedGroup: state => state.app.selectedGroup
    }),

    normalizedURL () {
      // Prepend `https://whalewisdom.com` to the given url if it's not yet there
      // return 'https://whalewisdom.com' + this.url.replace('https://whalewisdom.com', '')
      return this.url
    }
  },

  methods: {
    toЕxcel () {
      if (!this.user.isSubscriber) {
        this.subscriptionRequiredDialog = true
        return
      }

      this.loading = true

      if (this.criteria) {
        this.criteria.filers = this.selectedGroup.filers
        this.criteria.filer_group_id = this.selectedGroup.id
        this.$nextTick(() => {
          this.$refs.form.submit()
        })
      } else {
        window.location = this.normalizedURL
      }

      this.loading = false
    }
  }
}
</script>
